import React, { useState } from 'react'
import { Location } from '@reach/router'
import styled from 'styled-components'
import checkIcon from '../img/check-icon.svg'
import shareIcon from '../img/share-icon.svg'

const CopyToClipboard = () => {
  const [success, setSuccess] = useState(false)

  async function copy (copiedUrl) {
    await navigator.clipboard.writeText(copiedUrl)
    // alert('Text copied')
    setSuccess(true)
  }

  function renderSuccess () {
    setTimeout(() =>
      setSuccess(false), 3000)
    if (success === true) {
      return (
        <SuccessMsg>
          <img src={checkIcon} alt='Check' style={{ width: '1rem', height: '1rem', verticalAlign: 'middle' }} />{' '}Link kopiert
        </SuccessMsg>
      )
    }
  }

  return (
    <Location>
      {({ location }) => {
        const domain = 'https://www.digital-comfort-zone.com/products/11er-team-app/'
        const path = location.pathname
        const domainPath = domain + path

        return (
          <Wrapper>
            {renderSuccess()}
            <Btn
              onClick={() => copy(domainPath)}
              disabled={!domainPath}
            >
              <img src={shareIcon} alt='Teilen' style={{ width: '2rem', height: '2rem' }} />
              <p style={{ color: 'var(--color-text)', margin: '0rem' }}>Teilen</p>
            </Btn>
          </Wrapper>
        )
      }}
    </Location>
  )
}

export default CopyToClipboard

const Wrapper = styled.div`
  position: relative;
  // display: inline-block;
`

const Btn = styled.button`
  background: none;
  cursor: pointer;
  border: none;
`

const SuccessMsg = styled.div`
  position: absolute;
  right: 50px;
  bottom: 15px;
  // margin-bottom: 10px;
  background: hsl(141, 71%, 48%);
  padding: 5px 8px;
  color: #fff;
  display: inline-block;
  border-radius: 5px;
  animation: fadeIn 4s;
  -webkit-animation: fadeIn 4s;
  -moz-animation: fadeIn 4s;
  -o-animation: fadeIn 4s;
  -ms-animation: fadeIn 4s;
}

@keyframes fadeIn {
  0% {opacity: 0}
  20% {opacity: 1}
  100% {opacity:0}
}

@-moz-keyframes fadeIn {
  0% {opacity: 0}
  20% {opacity: 1}
  100% {opacity:0}
}

@-webkit-keyframes fadeIn {
  0% {opacity: 0}
  20% {opacity: 1}
  100% {opacity:0}
}

@-o-keyframes fadeIn {
  0% {opacity: 0}
  20% {opacity: 1}
  100% {opacity:0}
}

@-ms-keyframes fadeIn {
  0% {opacity: 0}
  20% {opacity: 1}
  100% {opacity:0}
}
`
